import * as Types from '../../../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FindResumeEngagementQueryVariables = Types.Exact<{
  resumeEngagementsCount?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  resumeEngagementsAfter?: Types.InputMaybe<Types.Scalars['String']['input']>;
  resumeEngagementsInput?: Types.FindResumeEngagementsInput;
}>;


export type FindResumeEngagementQuery = { __typename?: 'Query', findResumeEngagements?: { __typename?: 'FindResumeEngagementsConnection', engagements: Array<{ __typename?: 'ResumeEngagementResult', id: string, status: Types.ResumeEngagementStatus, createdDate: string, type: Types.TalentEngagementType, fullApplyRequested: boolean, sender: { __typename?: 'ResumeEngagementSender', name?: string | null, email?: string | null, id: string }, recipient: { __typename?: 'ResumeEngagementRecipient', id: string, email?: string | null, phoneNumber?: string | null }, job?: { __typename?: 'ResumeEngagementJob', title?: string | null, company?: string | null, description?: string | null, employerJobId?: string | null, htmlDescription?: string | null } | null, conversation: { __typename?: 'ResumeEngagementConversation', key: string, initialMessage: { __typename?: 'ResumeEngagementMessage', id: string, textBody?: string | null, htmlBody?: string | null } }, statusHistory: Array<{ __typename?: 'ResumeEngagementStatusEvent', status: Types.ResumeEngagementStatus, timestamp: number, modifiedDate: string }>, feedback?: { __typename?: 'ResumeEngagementJobSeekerFeedback', declineReason?: Types.ResumeEngagementDeclineReason | null, comment?: string | null } | null }> } | null };


export const FindResumeEngagementDocument = gql`
    query FindResumeEngagement($resumeEngagementsCount: Int = 50, $resumeEngagementsAfter: String = null, $resumeEngagementsInput: FindResumeEngagementsInput! = {}) {
  findResumeEngagements(
    first: $resumeEngagementsCount
    after: $resumeEngagementsAfter
    input: $resumeEngagementsInput
  ) {
    engagements {
      id
      sender {
        name
        email
        id
      }
      status
      createdDate
      type
      recipient {
        id
        email
        phoneNumber
      }
      job {
        title
        company
        description
        employerJobId
        htmlDescription
      }
      conversation {
        key
        initialMessage {
          id
          textBody
          htmlBody
        }
      }
      statusHistory {
        status
        timestamp
        modifiedDate
      }
      feedback {
        declineReason
        comment
      }
      fullApplyRequested
    }
  }
}
    `;

/**
 * __useFindResumeEngagementQuery__
 *
 * To run a query within a React component, call `useFindResumeEngagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindResumeEngagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindResumeEngagementQuery({
 *   variables: {
 *      resumeEngagementsCount: // value for 'resumeEngagementsCount'
 *      resumeEngagementsAfter: // value for 'resumeEngagementsAfter'
 *      resumeEngagementsInput: // value for 'resumeEngagementsInput'
 *   },
 * });
 */
export function useFindResumeEngagementQuery(baseOptions?: Apollo.QueryHookOptions<FindResumeEngagementQuery, FindResumeEngagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindResumeEngagementQuery, FindResumeEngagementQueryVariables>(FindResumeEngagementDocument, options);
      }
export function useFindResumeEngagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindResumeEngagementQuery, FindResumeEngagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindResumeEngagementQuery, FindResumeEngagementQueryVariables>(FindResumeEngagementDocument, options);
        }
export function useFindResumeEngagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindResumeEngagementQuery, FindResumeEngagementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindResumeEngagementQuery, FindResumeEngagementQueryVariables>(FindResumeEngagementDocument, options);
        }
export type FindResumeEngagementQueryHookResult = ReturnType<typeof useFindResumeEngagementQuery>;
export type FindResumeEngagementLazyQueryHookResult = ReturnType<typeof useFindResumeEngagementLazyQuery>;
export type FindResumeEngagementSuspenseQueryHookResult = ReturnType<typeof useFindResumeEngagementSuspenseQuery>;
export type FindResumeEngagementQueryResult = Apollo.QueryResult<FindResumeEngagementQuery, FindResumeEngagementQueryVariables>;